<!-- 暂无数据 -->
<template>
  <div class="ml_no_data_car" style="padding: 100px 0;text-align: center;">

    <img src="../assets/55.png" mode="aspectFill" class="ml_no_data_car_img"
      style="width: 76px;height: 76px;display: inline-block;" />

    <div class="ml_no_data_car_text" style="padding: 25px 0;color: #979797;">
      <template v-if="text == 'undefined' || text == ''">
        没有更多内容
      </template>
      <template v-else>
        {{ text || "没有更多内容" }}
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "compoent-no-data",
  data() {
    return {

    };
  },
  props: {
    text: {
      type: String,
      value: "没有更多内容",
    },
    img: {
      type: String,
      value: ''
    },
  }
}
</script>

<style lang="scss">
.ml_no_data_car {
  padding: 100px 0;
  text-align: center;

  .ml_no_data_car_img {
    width: 76px;
    height: 76px;
    display: inline-block;
    margin: 0 auto;
  }

  .ml_no_data_car_text {
    padding: 25px 0;
    color: #979797;
    font-size: 14px;
  }
}
</style>
